import { z } from 'zod';

export const TSDMarkCustomsNotificationAsReadSchema = z.object({
  tsdId: z.string().min(1, { message: 'Required' }),
  notificationId: z.string().min(1, { message: 'Required' }),
});

export type TSDMarkCustomsNotificationAsReadData = z.infer<typeof TSDMarkCustomsNotificationAsReadSchema>;
